import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import Kit from './Kit'

const InstallationKits = ({
  installationKits
}) =>
  <Kits>
    {
      installationKits.map((kit, index) =>
        <Kit
          key={ index }
          kit={ kit }
          success
          close />
      )
    }
  </Kits>

InstallationKits.propTypes = {
  installationKits: PropTypes.arrayOf(PropTypes.shape())
}

export default InstallationKits

const Kits = styled.div`
  ${Mixin.responsive('padding-bottom', '30px', '20px')}
`
